<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- <div class="top-container">
  <div class="chart-header top">
    <button class="align-right" mat-flat-button color="primary" (click)="newAssessment()">Neue Testung</button>
  </div>
</div> -->

<div class="accordion-head">
  <div class="content">
    <span class="type">Assessment</span>
    <span class="score-container">Letztes Testergebnis (Erfüllung)</span>
    <span class="date">Zeitpunkt der letzten Testung</span>
    <span class="accordion-item-description"></span>
  </div>
</div>
<cdk-accordion class="accordion" [multi]="true">
  @for (mixedItem of recentAssessmentChartDataSetsMixed(); track $index) {
    @if (mixedItem.standard; as item) {
      <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        [id]="item.type"
        [expanded]="false"
        class="accordion-item"
        role="button"
        tabindex="0">
        <div class="accordion-item-header" (click)="detailsEinOderAusblenden(accordionItem, mixedItem)">
          <span class="type">{{ item.type }}</span>
          <div class="score-container">
            @if (item.type === 'ARAT' || item.type === 'NHPT' || item.type === 'BBT') {
              <div class="score">
                <app-icf-bar-percent
                  class="subtest-score2"
                  [erfuellung]="true"
                  [value]="
                    item.score_left === null || item.score_left === undefined ? 0 : 100 - item.score_left
                  "></app-icf-bar-percent>
                <div class="label">links</div>
              </div>
              <div class="score">
                <app-icf-bar-percent
                  class="subtest-score2"
                  [erfuellung]="true"
                  [value]="
                    item.score_right === null || item.score_right === undefined ? 0 : 100 - item.score_right
                  "></app-icf-bar-percent>
                <div class="label">rechts</div>
              </div>
            }
            @if (item.type === 'BBS' || item.type === 'TUG' || item.type === 'FGA') {
              <app-icf-bar-percent
                class="subtest-score"
                [erfuellung]="true"
                [value]="item.score === null || item.score === undefined ? 0 : 100 - item.score"></app-icf-bar-percent>
            }
          </div>

          <span class="date"
            >zuletzt {{ item.dateIso | dateRelativ }} ({{ item.dateIso | date: 'EE, dd.MM.yyyy' }})</span
          >
          <span class="accordion-item-description">
            Details {{ accordionItem.expanded ? 'schliessen' : 'öffnen' }}
          </span>
        </div>
        <div
          class="accordion-item-body"
          role="region"
          [style.display]="accordionItem.expanded || initiallyOpenedAssessmentType === item.type ? '' : 'none'">
          <!-- <div class="accordion-item-body" role="region" [style.display]="accordionItem.expanded ? '' : 'none'"> -->
          @if (item.type === 'ARAT') {
            <div class="bar-container">
              @if (accordionItem.expanded || initiallyOpenedAssessmentType === item.type) {
                <!-- @if (true) { -->
                <app-line-chart-multi
                  [patient]="patientsService.patient()!"
                  [data]="assessmentChartDataSets()?.ARAT"
                  [dataFull]="assessmentChartDataSets"
                  (indexClicked)="onIndexClicked($event, appDetails)"
                  [selectedIndex]="appDetails.assessmentIndex()"
                  label="Erfüllung in %"
                  chartId="arat"
                  class="bar-item"></app-line-chart-multi>
                <app-details #appDetails [assessmentList]="assessmentList" [data]="mixedItem"></app-details>
              }
            </div>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-description>Liste der ARAT-Testungen</mat-panel-description>
              </mat-expansion-panel-header>
              <app-assessment-table-sub type="ARAT" [assessmentList]="assessmentList"></app-assessment-table-sub>
            </mat-expansion-panel>
          }
          @if (item.type === 'BBS') {
            <div class="bar-container">
              @if (accordionItem.expanded || initiallyOpenedAssessmentType === item.type) {
                <app-line-chart-single
                  [data]="assessmentChartDataSets()?.BBS"
                  [dataFull]="assessmentChartDataSets"
                  (indexClicked)="appDetails.assessmentIndex.set($event)"
                  [selectedIndex]="appDetails.assessmentIndex()"
                  label="Erfüllung in %"
                  chartId="bbs"
                  class="bar-item"></app-line-chart-single>
                <app-details #appDetails [assessmentList]="assessmentList" [data]="mixedItem"></app-details>
              }
            </div>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-description>Liste der BBS-Testungen</mat-panel-description>
              </mat-expansion-panel-header>
              <app-assessment-table-sub type="BBS" [assessmentList]="assessmentList"></app-assessment-table-sub>
            </mat-expansion-panel>
          }
          @if (item.type === 'TUG') {
            <div class="bar-container">
              @if (accordionItem.expanded || initiallyOpenedAssessmentType === item.type) {
                <app-line-chart-single
                  [data]="assessmentChartDataSets()?.TUG"
                  [dataFull]="assessmentChartDataSets"
                  (indexClicked)="appDetails.assessmentIndex.set($event)"
                  [selectedIndex]="appDetails.assessmentIndex()"
                  label="Erfüllung in %"
                  chartId="tug"
                  class="bar-item"></app-line-chart-single>
                <app-details #appDetails [assessmentList]="assessmentList" [data]="mixedItem"></app-details>
              }
            </div>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-description>Liste der TUG-Testungen</mat-panel-description>
              </mat-expansion-panel-header>
              <app-assessment-table-sub type="TUG" [assessmentList]="assessmentList"></app-assessment-table-sub>
            </mat-expansion-panel>
          }
          @if (item.type === 'FGA') {
            <div class="bar-container">
              @if (accordionItem.expanded || initiallyOpenedAssessmentType === item.type) {
                <app-line-chart-single
                  [data]="assessmentChartDataSets()?.FGA"
                  [dataFull]="assessmentChartDataSets"
                  (indexClicked)="appDetails.assessmentIndex.set($event)"
                  [selectedIndex]="appDetails.assessmentIndex()"
                  label="Erfüllung in %"
                  chartId="fga"
                  class="bar-item"></app-line-chart-single>
                <app-details #appDetails [assessmentList]="assessmentList" [data]="mixedItem"></app-details>
              }
            </div>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-description>Liste der FGA-Testungen</mat-panel-description>
              </mat-expansion-panel-header>
              <app-assessment-table-sub type="FGA" [assessmentList]="assessmentList"></app-assessment-table-sub>
            </mat-expansion-panel>
          }
          @if (item.type === 'BBT') {
            <div class="bar-container">
              @if (accordionItem.expanded || initiallyOpenedAssessmentType === item.type) {
                <app-line-chart-multi
                  [patient]="patientsService.patient()!"
                  [data]="assessmentChartDataSets()?.BBT"
                  [dataFull]="assessmentChartDataSets"
                  (indexClicked)="appDetails.assessmentIndex.set($event)"
                  [selectedIndex]="appDetails.assessmentIndex()"
                  label="Erfüllung in %"
                  chartId="bbt"
                  class="bar-item"></app-line-chart-multi>
                <app-details #appDetails [assessmentList]="assessmentList" [data]="mixedItem"></app-details>
              }
            </div>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-description>Liste der BBT-Testungen</mat-panel-description>
              </mat-expansion-panel-header>
              <app-assessment-table-sub type="BBT" [assessmentList]="assessmentList"></app-assessment-table-sub>
            </mat-expansion-panel>
          }
          @if (item.type === 'NHPT') {
            <div class="bar-container">
              @if (accordionItem.expanded || initiallyOpenedAssessmentType === item.type) {
                <app-line-chart-nhpt
                  [patient]="patientsService.patient()!"
                  [data]="assessmentChartDataSets()?.NHPT"
                  [dataFull]="assessmentChartDataSets"
                  (indexClicked)="appDetails.assessmentIndex.set($event)"
                  [selectedIndex]="appDetails.assessmentIndex()"
                  label="Erfüllung in %"
                  chartId="nhpt"
                  class="bar-item"></app-line-chart-nhpt>
                <app-details #appDetails [assessmentList]="assessmentList" [data]="mixedItem"></app-details>
              }
            </div>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-description>Liste der NHPT-Testungen</mat-panel-description>
              </mat-expansion-panel-header>
              <app-assessment-table-sub type="NHPT" [assessmentList]="assessmentList"></app-assessment-table-sub>
            </mat-expansion-panel>
          }
        </div>
      </cdk-accordion-item>
    }
    @if (mixedItem.custom; as item) {
      <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        [id]="'custom' + item.customAssessment.id"
        [expanded]="false"
        class="accordion-item"
        role="button"
        tabindex="0">
        <div class="accordion-item-header" (click)="detailsEinOderAusblenden(accordionItem, mixedItem)">
          <span class="type">{{ item.customAssessment.shortName }}</span>
          <div class="score-container">
            @if (item.customAssessment.sideDistinction) {
              <!-- ab Angular 18: @let recentItem = item.assessmentChartDataRows[0]; -->
              <div class="score">
                <app-icf-bar-percent
                  class="subtest-score2"
                  [erfuellung]="true"
                  [value]="
                    item.assessmentChartDataRows[0].score_left === null ||
                    item.assessmentChartDataRows[0].score_left === undefined
                      ? 0
                      : 100 - item.assessmentChartDataRows[0].score_left
                  "></app-icf-bar-percent>
                <div class="label">links</div>
              </div>
              <div class="score">
                <app-icf-bar-percent
                  class="subtest-score2"
                  [erfuellung]="true"
                  [value]="
                    item.assessmentChartDataRows[0].score_right === null ||
                    item.assessmentChartDataRows[0].score_right === undefined
                      ? 0
                      : 100 - item.assessmentChartDataRows[0].score_right
                  "></app-icf-bar-percent>
                <div class="label">rechts</div>
              </div>
            } @else {
              <app-icf-bar-percent
                class="subtest-score"
                [erfuellung]="true"
                [value]="
                  item.assessmentChartDataRows[0].score_left === null ||
                  item.assessmentChartDataRows[0].score_left === undefined
                    ? 0
                    : 100 - item.assessmentChartDataRows[0].score_left
                "></app-icf-bar-percent>
            }
          </div>

          <span class="date"
            >zuletzt {{ item.assessmentChartDataRows[0].dateIso | dateRelativ }} ({{
              item.assessmentChartDataRows[0].dateIso | date: 'EE, dd.MM.yyyy'
            }})</span
          >
          <span class="accordion-item-description">
            Details {{ accordionItem.expanded ? 'schliessen' : 'öffnen' }}
          </span>
        </div>
        <div
          class="accordion-item-body"
          role="region"
          [style.display]="
            accordionItem.expanded || initiallyOpenedCustomId === item.customAssessment.id ? '' : 'none'
          ">
          @if (item.customAssessment.sideDistinction) {
            <div class="bar-container">
              @if (accordionItem.expanded || initiallyOpenedCustomId === item.customAssessment.id) {
                <app-line-chart-multi
                  [patient]="patientsService.patient()!"
                  [data]="item.assessmentChartDataRows"
                  [dataFull]="assessmentChartDataSets"
                  (indexClicked)="appDetails.assessmentIndex.set($event)"
                  [selectedIndex]="appDetails.assessmentIndex()"
                  label="Erfüllung in %"
                  chartId="custom"
                  class="bar-item"></app-line-chart-multi>
                <app-details
                  #appDetails
                  [assessmentList]="assessmentList"
                  [customAssessment]="item.customAssessment"
                  [data]="mixedItem"></app-details>
              }
            </div>
          } @else {
            <div class="bar-container">
              @if (accordionItem.expanded || initiallyOpenedCustomId === item.customAssessment.id) {
                <app-line-chart-single
                  [data]="item.assessmentChartDataRows"
                  [dataFull]="assessmentChartDataSets"
                  (indexClicked)="appDetails.assessmentIndex.set($event)"
                  [selectedIndex]="appDetails.assessmentIndex()"
                  label="Erfüllung in %"
                  chartId="custom"
                  class="bar-item"></app-line-chart-single>
                <app-details
                  #appDetails
                  [assessmentList]="assessmentList"
                  [customAssessment]="item.customAssessment"
                  [data]="mixedItem"></app-details>
              }
            </div>
          }
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-description>Liste der {{ item.customAssessment.shortName }}-Testungen</mat-panel-description>
            </mat-expansion-panel-header>
            <app-assessment-table-sub
              type="CUSTOM"
              [customAssessment]="item.customAssessment"
              [assessmentList]="assessmentList"></app-assessment-table-sub>
          </mat-expansion-panel>
        </div>
      </cdk-accordion-item>
    }
  }
</cdk-accordion>
